import React from 'react';
import { COLOR_TOKEN } from '../constants/styles-constants';

// Normaliza cada carácter (minúsculas, sin acentos) manteniendo la longitud 1:1 con el original, para poder localizar coincidencias respetando los índices del texto original.
function foldText(text: string): string {
	return Array.from(text)
		.map((char) =>
			char
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.toLowerCase(),
		)
		.join('');
}

// Devuelve el texto con las coincidencias del término de búsqueda destacadas.
export function highlightMatch(text: string | undefined, query?: string): React.ReactNode {
	if (!text || !query) return text;
	const foldedQuery = foldText(query.trim());
	if (!foldedQuery) return text;

	const foldedText = foldText(text);
	const parts: React.ReactNode[] = [];
	let lastIndex = 0;
	let index = foldedText.indexOf(foldedQuery);
	while (index !== -1) {
		if (index > lastIndex) {
			parts.push(text.slice(lastIndex, index));
		}
		parts.push(
			<mark
				key={index}
				style={{
					backgroundColor: 'transparent',
					color: COLOR_TOKEN.content.hover,
					fontWeight: 700,
					textDecoration: 'underline',
				}}
			>
				{text.slice(index, index + foldedQuery.length)}
			</mark>,
		);
		lastIndex = index + foldedQuery.length;
		index = foldedText.indexOf(foldedQuery, lastIndex);
	}
	if (lastIndex < text.length) {
		parts.push(text.slice(lastIndex));
	}
	return parts;
}
